<template>
  <b-modal @hide="createModalClose" ref="userModal" :title="$t('担当者情報登録')" size="lg">
    <b-container fluid>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("氏名") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <input v-model="create.form.name" type="text" class="form-control"  />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("カナ") }}
        </label>
        <div class="col-sm-8">
          <input v-model="create.form.kana" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">{{ $t("管理コード") }}</label>
        <div class="col-sm-8">
          <input v-model="create.form.code" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("工場") }}
        </label>
        <div class="col-sm-8">
          <select class="form-control" v-model.number="create.form.site">
            <option :value="null"></option>
            <template v-for="(item ,index) in mixinSpacesListDisplay('site')" :keyed="`site-${index}`">
              <option :value="item.id" :key="`site-${index}`">{{ item.name }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("部署") }}
        </label>
        <div class="col-sm-8">
          <select class="form-control" v-model.number="create.form.dep">
            <option :value="null"></option>
            <template v-for="(item ,index) in mixinSpacesListDisplay('dep')" :keyed="`dep-${index}`">
              <option :value="item.id" :key="`dep-${index}`">{{ item.name }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("時間単価[円/時間]") }}
        </label>
        <div class="col-sm-8" v-if="create.form">
          <input v-model.number="create.form.hourPrice" type="number" class="form-control"  />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("シフト") }}
        </label>
        <div class="col-sm-8">
          <select class="form-control" v-model="create.form.workTime">
            <option value=""></option>
            <template v-for="(item ,index) in workTimes" :keyed="`worktime-${index}`">
              <option :value="index" :key="`worktime-${index}`">{{ item }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("表示順") }}
        </label>
        <div class="col-sm-8" v-if="create.form">
          <input v-model.number="create.form.sort" type="number" class="form-control"  />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("ログインID") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <input v-model="create.form.loginId" type="text" class="form-control"  />
        </div>
      </div>
      <div v-if="showPassword" class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("パスワード") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <input v-model="create.form.password" type="password" class="form-control"/>
        </div>
      </div>
      <div v-if="showPassword" class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("パスワード（確認）") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <input v-model="create.form.passwordConfirm" type="password" class="form-control"/>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("通知用メールアドレス") }}
        </label>
        <div class="col-sm-8">
          <input v-model="create.form.email" type="email" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("言語") }}
        </label>
        <div class="col-sm-8">
          <select class="form-control" v-model="create.form.languageCode">
            <template>
              <option
                v-for="(item, index) in language"
                :key="index"
                :value="item.code"
              >{{ $t(item.name) }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("地域") }}
        </label>
        <div class="col-sm-8">
          <select class="form-control" v-model="create.form.countryCode">
            <template>
              <option
                v-for="(item, index) in country"
                :key="index"
                :value="item.code"
              >{{ $t(item.name) }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="displayColor" class="col-sm-4 col-form-label">
          <tooltip
            :text="$t('工程表示色')"
            icon="fa-question-circle"
            position="position-left-top"
            :msg="$t('担当者'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart)"
            :msgMaxLength="$t('担当者'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart).length"
            :isDisplayColorBtn="false"
          ></tooltip>
        </label>
        <div class="col-sm-8">
          <button
            id="displayColor"
            type="button"
            class="form-control btn btn-color-circle"
            :style="displayColorStyle"
            @click="displayColorModalOpen()"
          >
          </button>
          <label class="col-sm-4 col-form-label">
            {{ $t(displayColorName) }}
          </label>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t("権限") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <div v-if="'company' in master && 'privilege' in master.company">
            <label class="mr-4" v-for="(item,key) in master.company.privilege" :key="key">
              <input v-model.number="create.form.privilege" type="radio" name="privilege" :value="item" required="">
                {{ $t(key) }}
            </label>
          </div>
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          @click="createRegister()"
          :disabled="create.registration"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="create.registration"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t("登録") }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          @click="createModalClose()"
          v-if="!create.confirm"
          :disabled="create.registration"
        >{{ $t("キャンセル") }}</button>
      </div>
    </template>
    <selectDisplayColorModal
      ref="selectDisplayColorModal"
      :flg="colorModalFlg"
      :displayColorStyle="this.displayColorStyle"
      @modal-close="setDisplayColor">
    </selectDisplayColorModal>
  </b-modal>
</template>

<script>
import config from '@/config'
import country from '../../assets/json/country.json'
import language from '../../assets/json/language.json'
import selectDisplayColorModal from '@/components/selectDisplayColorModal.vue'
import tooltip from '@/components/tooltip.vue'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      country: country,
      language: language,
      master: {},
      workTimes: {
        'workTime1': this.$t('シフト1'),
        'workTime2': this.$t('シフト2'),
        'workTime3': this.$t('シフト3'),
      },
      displayColorName: config.userDisplayColors.green.name,
      displayColorStyle: {'background-color': '', 'border-color': ''},
      create: {
        load: false,
        form: {
          id: null,
          cognitoUId: null,
          loginId: '',
          password: '',
          passwordConfirm: '',
          name: '',
          kana: '',
          code: '',
          workTime: '',
          sort: null,
          privilege: '1000',
          languageCode: this.$store.getters['auth/userdata'].languageCode,
          countryCode: this.$store.getters['auth/userdata'].countryCode,
          displayColor: config.userDisplayColors.green.val,
          hourPrice: 0,
          site: null,
          dep: null,
          processIds: [],
          email: '',
        },
        registration: false,
        error: '',
      },
      loginId: '',
      colorModalFlg: 'modal-display-color modal-display-color-user',
    }
  },
  props: {
    isUpdate: Boolean,
  },
  components: {
      tooltip,
      selectDisplayColorModal,
  },
  methods: {
    // モーダルを開いたときの処理
    async createModalOpen(item, processId = null) {
      await this.getMasterData()
      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        if (copy.spaces.site) copy.site = copy.spaces.site
        if (copy.spaces.dep) copy.dep = copy.spaces.dep
        delete copy.spaces
        this.create.form = copy
        this.loginId = copy.loginId
      }
      this.updateDisplayColor()
      const baseCSS = 'modal-display-color modal-display-color-user'
      this.colorModalFlg = this.isUpdate ? `${baseCSS}-update` : baseCSS
      if (processId) this.create.form.processIds.push(processId)
      this.$refs.userModal.show()
    },
    async getMasterData() {
      try {
        this.master = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async createRegister() {
      const pwd = this.create.form
      if (!pwd.name) {
        this.create.error = this.$t('氏名') + this.$t('必須メッセージ')
        return
      } else if (!this.isKana(pwd.kana) && pwd.kana != '' && pwd.kana != null) {
        this.create.error = this.$t('カナの入力が正しくありません。')
        return
      } else if (!pwd.loginId) {
        this.create.error = this.$t('ログインID') + this.$t('必須メッセージ')
        return
      } else if (this.showPassword && !pwd.password && 'password' in pwd) {
        this.create.error = this.$t('パスワード') + this.$t('必須メッセージ')
        return
      } else if (this.showPassword && (pwd.password.length < 6)) {
        this.create.error = this.$t('パスワードは6文字以上で入力して下さい')
        return
      } else if (this.showPassword && pwd.password != pwd.passwordConfirm && 'password' in pwd) {
        this.create.error = this.$t('パスワードとパスワード（確認）が一致しません。')
        return
      } else if (!pwd.privilege) {
        this.create.error = this.$t('権限') + this.$t('必須メッセージ')
        return
      } else {
        this.create.error = ''
      }
      this.create.registration = true
      // ユーザー登録のパラメーターを定義
      const params = this.mixin_deepcopy(this.create.form)
      delete params.passwordConfirm
      let method = 'post'
      if (this.create.form.id) method = 'put'
      try {
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/user`,
          data: params,
        })

        this.$emit('registed')
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.destroyModal()
      } catch (err) {
        if (err.response.data.code === '0024') {
          this.$toasted.show(((targetName) =>
            this.$t(`${targetName}は既に登録されています`)
          )(this.create.form.loginId))
        } else {
          this.$toasted.show(this.$t('データ登録エラーメッセージ'))
        }
      }
      this.create.registration = false
    },
    destroyModal() {
      this.$refs.userModal.hide()
      this.create = {
        load: false,
        all_day: false,
        form: {
          id: null,
          cognitoUId: null,
          loginId: '',
          password: '',
          passwordConfirm: '',
          name: '',
          kana: '',
          code: '',
          workTime: '',
          privilege: '1000',
          languageCode: 'ja',
          countryCode: this.$store.getters['auth/userdata'].countryCode,
          displayColor: config.userDisplayColors.green.val,
          hourPrice: 0,
          site: null,
          dep: null,
          processIds: [],
          email: '',
        },
        registration: false,
        error: '',
      }
    },
    createModalClose() {
      this.$emit('modal-close')
      this.destroyModal()
    },
    displayColorModalOpen() {
      this.$refs.selectDisplayColorModal.modalOpen()
    },
    updateDisplayColor() {
      this.displayColorName = Object.values(config.processDisplayColors).find(color => this.create.form.displayColor === color.val)?.name
      this.setDisplayColorStyle()
    },
    setDisplayColor(data) {
      if (data.hex && data.name) {
        this.create.form.displayColor = data.hex
        this.displayColorName = data.name
        this.setDisplayColorStyle()
      }
    },
    setDisplayColorStyle() {
      this.displayColorStyle = {'background-color': this.create.form.displayColor, 'border-color': this.create.form.displayColor}
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
    showPassword() {
      if (this.create.form.id) {
        if (this.create.form.loginId !== this.loginId) {
          return true
        } else {
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
#userModal {
  .modal-dialog {
    max-width: 100rem;
  }
}
</style>
